export default __webpack_public_path__ + "static/media/2001.d180aa4a.webp";